<template>
    <SwLayout>
        <div class="dm-wizard-field" v-if="presentation">
            <SelectCoverTypeTabs />

            <CustomCoverManager
                v-if="presentation.cover_image_type == 'custom'"
            />

            <DefaultCoverManager
                v-if="presentation.cover_image_type == 'default'"
            />
        </div>
    </SwLayout>
</template>

<script>
import { validationMixin } from "@/mixins/validationMixin.js";

import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState } from "pinia";

import SelectCoverTypeTabs from "./partials/SelectCoverTypeTabs.vue";
import CustomCoverManager from "./partials/custom-cover-manager/CustomCoverManager.vue";
import DefaultCoverManager from "./partials/default-cover-manager/DefaultCoverManager.vue";

export default {
    components: {
        SelectCoverTypeTabs,
        CustomCoverManager,
        DefaultCoverManager,
    },

    mixins: [validationMixin],

    computed: {
        ...mapWritableState(useSubmissionWizardStore, [
            "presentation",
            "bottom_navigation_rules",
        ]),

        isValid() {
            if (!this.presentation) return false;

            if (this.presentation.cover_image_type == "default") {
                return this.presentation.default_cover_image_id ? true : false;
            }

            if (this.presentation.cover_image_type == "custom") {
                return this.presentation.has_custom_cover_image;
            }
            return false;
        },
    },
};
</script>
